import { NgModule } from '@angular/core';
import { FormModule } from 'lib/ui/form/form.module.js';
import { CoreModule } from 'src/app/core/core.module.js';
import { LayoutModule } from '../../layout/layout.module.js';
import { UsersModule } from '../../modules/users/users.module';
import { ConfirmEmailComponent } from './confirm-email.component.js';
import { ForgottenPasswordComponent } from './forgotten-password.component.js';
import { LoginComponent } from './login.component.js';
import { ResetPasswordComponent } from './reset-password.component.js';
import { SignupComponent } from './signup.component.js';
import { UnsubscribeComponent } from './unsubscribe.component.js';

@NgModule({
	imports: [CoreModule, FormModule, LayoutModule, UsersModule],
	declarations: [
		LoginComponent,
		SignupComponent,
		ForgottenPasswordComponent,
		ResetPasswordComponent,
		UnsubscribeComponent,
		ConfirmEmailComponent
	],
	exports: [
		LoginComponent,
		SignupComponent,
		ForgottenPasswordComponent,
		ResetPasswordComponent,
		UnsubscribeComponent,
		ConfirmEmailComponent
	]
})
export class AuthModule {}
